import React from 'react';
import moment from 'moment';
import api from 'api';
import { Spinner, ConfirmModal } from 'hyperdb-utils';
import ModalForm from './ModalForm';

class Payments extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddPayment = this.handleAddPayment.bind(this);
    this.handleEditPayment = this.handleEditPayment.bind(this);
    this.handleCloseModalPayment = this.handleCloseModalPayment.bind(this);
    this.handleSavePayment = this.handleSavePayment.bind(this);
    this.toggleModalDelete = this.toggleModalDelete.bind(this);
    this.handleDeletePayment = this.handleDeletePayment.bind(this);
  }
  componentDidMount() {
    this.getPayments(this.props.reservation);
  }
  componentWillReceiveProps(nextProps) {
    const isNew = this.props.reservation.reference !== nextProps.reservation.reference;
    if (nextProps.submitSuccessful || nextProps.deleteSuccessful || isNew) {
      this.props.api.payment.setData({ submitSuccessful: false, deleteSuccessful: false, objectData: null, paymentToDelete: null });
      this.getPayments(nextProps.reservation);
      if (this.props.onChange) this.props.onChange();
    }
  }
  componentWillUnmount() {
    this.props.api.payment.setData({
      payments: null,
      objectData: null,
      paymentToDelete: null,
    });
  }
  render() {
    if (!this.props.payments) return <div className="box box-primary"><Spinner show={ true } /></div>;
    return (
      <div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th colSpan="4"><button type="buttom" onClick={ this.handleAddPayment } className="btn btn-primary btn-sm">Add payment</button></th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.payments.map((payment, i) => {
                return (
                  <tr key={ i }>
                    <td>{ payment.amount } { payment.currency }</td>
                    <td>{ payment.payment_method }</td>
                    <td>{ payment.transaction_date ? moment(payment.transaction_date).format('DD/MM/YYYY') : '' }</td>
                    <td>
                      <button type="buttom" onClick={ this.handleEditPayment.bind(null, i) } className="btn btn-primary btn-xs">Edit</button>
                      &nbsp;<button type="buttom" onClick={ this.toggleModalDelete.bind(null, i) } className="btn btn-danger btn-xs">Delete</button>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        Total paid &nbsp;<strong>{ this.totalPaid() } { this.props.reservation.currency }</strong>
        <br/>
        Left to pay &nbsp;<strong>{ Math.round(this.props.reservation.total_price) - this.totalPaid() } { this.props.reservation.currency }</strong>
      {
        this.props.objectData
          ? <ModalForm
              title={ this.modalFormTitle() }
              reservation={ this.props.reservation }
              onCancel={ this.handleCloseModalPayment }
              onSubmit={ this.handleSavePayment } />
          : null
      }
      {
        this.props.paymentToDelete
          ? <ConfirmModal
              title="Delete payment"
              onClose={ this.toggleModalDelete.bind(this, -1) }
              onConfirm={ this.handleDeletePayment }
              loading={ this.props.loading }>
                Are you sure you want to delete this payment ?
            </ConfirmModal>
          : null
      }
      </div>
    );
  }
  getPayments(reservation) {
    const url = `?reservationId=${reservation.id}`;
    this.props.api.payment.getData({ url, propName: 'payments' });
  }
  totalPaid() {
    return this.props.payments ? this.props.payments.reduce((total, b) => total + parseInt(b.amount || 0), 0) : null;
  }

  handleAddPayment() {
    this.props.api.payment.setData({ objectData: {} });
  }
  handleEditPayment(index) {
    const payment = { ...this.props.payments[index] };
    this.props.api.payment.setData({ objectData: payment });
  }
  modalFormTitle() {
    return this.props.objectData.id ? 'Edit payment' : 'Add payment';
  }
  handleCloseModalPayment() {
    this.props.api.payment.setData({ objectData: null });
  }
  handleSavePayment(payment) {
    if (!this.props.objectData.id) { // Create
      this.props.api.payment.submitCreateForm(payment);
    } else { // Update
      this.props.api.payment.submitEditForm({ id: this.props.objectData.id, objectData: payment });
    }
  }
  toggleModalDelete(index) {
    const paymentToDelete = index !== -1 ? { ...this.props.payments[index] } : null;
    this.props.api.payment.setData({ paymentToDelete });
  }
  handleDeletePayment() {
    this.props.api.payment.deleteObject(this.props.paymentToDelete);
  }
}

Payments.propTypes = {
  api: React.PropTypes.object,
  reservation: React.PropTypes.object,
  onChange: React.PropTypes.func,
};

export default api.connect(Payments, 'payment');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/payment/containers/Payments.jsx